<!-- TODO:
Convert every tab in separate components
Convert literals in i18n
-->

<template lang="pug">
  .commerce-info
    ods-tabs(v-model='activeTab' ref="tabs")
      ods-tab-pane(label='Datos comercio' name='1002' v-if="tabVisible(1000, 1002)" lazy)
        ods-module.commerce-info__module
          h1.commerce-info__title.tp-m-deci {{ commerceData.descomercio }}
          .commerce-info__grid-container
            .info-box
              .info-box__title.tp-r-deci {{ this.$t('commerceInfo.codeInCommerce') }}
              .info-box__data {{ commerceData.codcom }}
            .info-box
              .info-box__title.tp-r-deci {{ this.$t('commerceInfo.chain') }}
              .info-box__data {{ commerceData.descadena }}
            .info-box
              .info-box__title.tp-r-deci {{ this.$t('commerceInfo.address') }}
              .info-box__data
                ods-icon(
                  name="location"
                  color="#888A91"
                  size="20"
                  class="info-icon")
                p {{ commerceData.tipvia }} {{ commerceData.nomvia }}, {{ commerceData.numvia }}
                p {{ commerceData.codpostal }}
                p {{ commerceData.poblacion }}, {{ commerceData.desprov }}
            .info-box
              .info-box__title.tp-r-deci {{ this.$t('commerceInfo.status') }}
              .info-box__data {{ commerceData.fecbaja.anno === 0 ? 'Activo' : 'No activo' }}
            .info-box
              .info-box__title.tp-r-deci {{ this.$t('commerceInfo.product') }}
              .info-box__data {{ commerceData.desprod }}
            .info-box
              .info-box__title.tp-r-deci {{ this.$t('commerceInfo.rateType') }}
              .info-box__data
                ods-icon(
                  name="ahorro"
                  color="#888A91"
                  size="20"
                  class="info-icon")
                p {{ commerceData.descon }}

      ods-tab-pane(label='Tarifario' name='1003' v-if="tabVisible(1000, 1003)" lazy)
        ods-module.commerce-info__module--left-tabs
          ods-tabs(
            tab-position='left'
            class="left-tabs"
            v-model='activeTariffTab'
            ref="tabTariff"
            )
            ods-tab-pane(label='General' name="1013" v-if="tabVisible(1000, 1003, 1013)" lazy)
              p.tp-m-deci.ods-mb-6 {{ this.$t('commerceInfo.ratesGeneral') }}
              //- .filters-row
              //-   ods-input-search(
              //-     size='hecto'
              //-     outlined
              //-     placeholder='Buscar'
              //-     @input='tariffDataSearch')

              tariff-table.ods-mt-6()

            ods-tab-pane(label='Tipos de tarjetas' name="1023" v-if="tabVisible(1000, 1003, 1023)" lazy)
              p.tp-m-deci.ods-mb-6 {{ this.$t('commerceInfo.ratesCards') }}
              //- .filters-row
              //-   ods-input-search(
              //-     size='hecto'
              //-     outlined
              //-     placeholder='Buscar'
              //-     @input='cardtypeSearch')

              cardtype-table.ods-mt-6(:commerce="commerceData")

            ods-tab-pane(label='Tipos de Financiación' name="1033" v-if="tabVisible(1000, 1003, 1033)" lazy)
              p.tp-m-deci.ods-mb-6 {{ this.$t('commerceInfo.ratesFinancing') }}
              //- .filters-row
              //-   ods-input-search(
              //-     size='hecto'
              //-     outlined
              //-     placeholder='Buscar'
              //-     @input='productTypeSearch')

              producttype-table.ods-mt-6(:commerce="commerceData")

            ods-tab-pane(label='Tipos de Rappel' name="1034" v-if="tabVisible(1000, 1003, 1034)" lazy)
              p.tp-m-deci.ods-mb-6 {{ $t('commerceInfo.ratesRappel') }}
              //- .filters-row
              //-   ods-input-search(
              //-     size='hecto'
              //-     outlined
              //-     placeholder='Buscar'
              //-     @input='rateRappelSearch')

              rateRappel-table.ods-mt-6(:comercio="commerceData")

      ods-tab-pane(label='Consultas' name='1004' v-if="tabVisible(1000, 1004)" lazy)
        ods-module.commerce-info__module--left-tabs
          ods-tabs(
            tab-position='left'
            class="left-tabs"
            v-model='activeInquiriesTab'
            ref="tabInquiries"
            )
            ods-tab-pane(label='Facturación' name="1041" v-if="tabVisible(1000, 1004, 1041)" lazy)
              p.tp-m-deci.ods-mb-6 Consultas de Facturación
              //- .flex-container.space-between.align-center.filters-row
              //-   .flex-container.align-center
              //-     ods-input-search(
              //-       size='hecto'
              //-       outlined
              //-       placeholder='Buscar'
              //-       @input='billingDataSearch')
              //-     ods-actions-menu.advanced-search(
              //-       text="BÚSQUEDA AVANZADA"
              //-       customClass="advanced-search-card"
              //-       color="#888A91"
              //-       size="10"
              //-       popoverPosition="bottom-start")
              //-       .flex-container.space-between.align-center.ods-mb-4
              //-         span Fecha de Solicitud
              //-         ods-button(type="text" v-if="clearBillingButtonVisibility" @click="clearDateSearchBilling").clear-date.ods-p-0 Limpiar
              //-       ods-date-picker(
              //-         v-model='dateSearchBilling'
              //-         type='daterange'
              //-         :only-one-calendar="true"
              //-         :calendar-always-visible="false"
              //-         placeholder='Selecciona día'
              //-         :clearable="false")
              //-       ods-button(size="small" @click="billingFilterButton").ods-ml-4 Aplicar
              //-   .flex-container.align-center
              //-     span.tp-r-nano {{ rowSelectedTitle }}
              //-     ods-divider(v-if="rowSelectedCount" direction='vertical')
              //-     ods-actions-menu(
              //-       customClass="card-menu"
              //-       icon="overflow-menu"
              //-       color="#888A91"
              //-       size="18"
              //-       popoverPosition="bottom-end")
              //-       ul.menu
              //-         li.menu__item
              //-           a(href="#" @click.prevent="showExport = true")
              //-             ods-icon(name="file_export" color="#B6B6B6" size="24" style="vertical-align: middle").ods-mr-2
              //-             | Exportar
              //-         li.menu__item
              //-           a(href="#" @click.prevent="")
              //-             ods-icon(name="print" color="#B6B6B6" size="24" style="vertical-align: middle").ods-mr-2
              //-             | Imprimir
              billing-table(:comercio="commerceData")

            ods-tab-pane(label='Comisiones' name="1042" v-if="tabVisible(1000, 1004, 1042)" lazy)
              p.tp-m-deci.ods-mb-6 Consultas de Comisiones
              //- .flex-container.space-between.align-center.filters-row
              //-   .flex-container.align-center
              //-     ods-input-search(
              //-       size='hecto'
              //-       outlined
              //-       placeholder='Buscar'
              //-       @input='commissionsDataSearch')
              //-     ods-actions-menu.advanced-search(
              //-       text="BÚSQUEDA AVANZADA"
              //-       customClass="advanced-search-card"
              //-       color="#888A91"
              //-       size="10"
              //-       popoverPosition="bottom-start")
              //-       .flex-container.space-between.align-center.ods-mb-4
              //-         span Fecha de Solicitud
              //-         ods-button(type="text" v-if="clearCommissionsButtonVisibility" @click="clearDateSearchCommissions").clear-date.ods-p-0 Limpiar
              //-       ods-date-picker(
              //-         v-model='dateSearchCommissions'
              //-         type='daterange'
              //-         :only-one-calendar="true"
              //-         :calendar-always-visible="false"
              //-         placeholder='Selecciona día'
              //-         :clearable="false")
              //-       ods-button(size="small" @click="commissionsFilterButton").ods-ml-4 Aplicar
              //-   .flex-container.align-center
              //-     span.tp-r-nano {{ rowSelectedTitle }}
              //-     ods-divider(v-if="rowSelectedCount" direction='vertical')
              //-     ods-actions-menu(
              //-       customClass="card-menu"
              //-       icon="overflow-menu"
              //-       color="#888A91"
              //-       size="18"
              //-       popoverPosition="bottom-end")
              //-       ul.menu
              //-         li.menu__item
              //-           a(href="#" @click.prevent="showExport = true")
              //-             ods-icon(name="file_export" color="#B6B6B6" size="24" style="vertical-align: middle").ods-mr-2
              //-             | Exportar
              //-         li.menu__item
              //-           a(href="#" @click.prevent="")
              //-             ods-icon(name="print" color="#B6B6B6" size="24" style="vertical-align: middle").ods-mr-2
              //-             | Imprimir
              commissions-table.ods-mt-6(:comercio="commerceData")

            ods-tab-pane(label='Rappel' name="1043" v-if="tabVisible(1000, 1004, 1043)" lazy)
              p.tp-m-deci.ods-mb-6 Consultas de Rappel
              //- .flex-container.space-between.align-center.filters-row
              //-   .flex-container.align-center
              //-     ods-input-search(
              //-       size='hecto'
              //-       outlined
              //-       placeholder='Buscar'
              //-       @input='rappelDataSearch')
              //-     ods-actions-menu.advanced-search(
              //-       text="BÚSQUEDA AVANZADA"
              //-       customClass="advanced-search-card"
              //-       color="#888A91"
              //-       size="10"
              //-       popoverPosition="bottom-start")
              //-       .flex-container.space-between.align-center.ods-mb-4
              //-         span Fecha de Solicitud
              //-         ods-button(type="text" v-if="clearRappelButtonVisibility" @click="clearDateSearchRappel").clear-date.ods-p-0 Limpiar
              //-       ods-date-picker(
              //-         v-model='dateSearchRappel'
              //-         type='daterange'
              //-         :only-one-calendar="true"
              //-         :calendar-always-visible="false"
              //-         placeholder='Selecciona día'
              //-         :clearable="false")
              //-       ods-button(size="small" @click="rappelFilterButton").ods-ml-4 Aplicar
              //-   .flex-container.align-center
              //-     span.tp-r-nano {{ rowSelectedTitle }}
              //-     ods-divider(v-if="rowSelectedCount" direction='vertical')
              //-     ods-actions-menu(
              //-       customClass="card-menu"
              //-       icon="overflow-menu"
              //-       color="#888A91"
              //-       size="18"
              //-       popoverPosition="bottom-end")
              //-       ul.menu
              //-         li.menu__item
              //-           a(href="#" @click.prevent="showExport = true")
              //-             ods-icon(name="file_export" color="#B6B6B6" size="24" style="vertical-align: middle").ods-mr-2
              //-             | Exportar
              //-         li.menu__item
              //-           a(href="#" @click.prevent="")
              //-             ods-icon(name="print" color="#B6B6B6" size="24" style="vertical-align: middle").ods-mr-2
              //-             | Imprimir
              rappel-table.ods-mt-6(:comercio="commerceData")

            ods-tab-pane(label='Terminales' name="1044" v-if="tabVisible(1000, 1004, 1044)" lazy)
              p.tp-m-deci.ods-mb-6 Consultas de Terminales
              //- .flex-container.space-between.align-center.filters-row
              //-   .flex-container.align-center
              //-     ods-input-search(
              //-       size='hecto'
              //-       outlined
              //-       placeholder='Buscar'
              //-       @input='terminalsDataSearch')
              terminals-inquiries-table.ods-mt-6(:comercio="commerceData")

      ods-tab-pane(label='Recibos' name='1005' v-if="tabVisible(1000, 1005)" lazy)
        ods-module.commerce-info__module
          p.tp-m-deci.ods-mb-6 {{ $t('commerceInfo.listReceipts') }}
          //- .flex-container.space-between.align-center
          //-   .flex-container.align-center
          //-     ods-input-search(
          //-       size='hecto'
          //-       outlined
          //-       placeholder='Buscar'
          //-       @input='receiptsSearch'
          //-       )
          //-   .flex-container.align-center
          //-     span.tp-r-nano {{ rowSelectedTitle }}
          //-     ods-divider(v-if="rowSelectedCount" direction='vertical')
          //-     ods-actions-menu(
          //-       customClass="card-menu"
          //-       icon="overflow-menu"
          //-       color="#888A91"
          //-       size="18"
          //-       popoverPosition="bottom-end")
          //-       ul.menu
          //-         li.menu__item
          //-           a(href="#" @click.prevent="showExport = true")
          //-             ods-icon(name="file_export" color="#B6B6B6" size="24" style="vertical-align: middle").ods-mr-2
          //-             | Exportar
          //-         li.menu__item
          //-           a(href="#" @click.prevent="")
          //-             ods-icon(name="print" color="#B6B6B6" size="24" style="vertical-align: middle").ods-mr-2
          //-             | Imprimir

          receipts-table.ods-mt-6(:comercio="commerceData")

      ods-tab-pane(label='Vendedores' name='1006' v-if="tabVisible(1000, 1006)" lazy)
        ods-module.commerce-info__module
          p.tp-m-deci.ods-mb-6 {{ this.$t('commerceInfo.listVendors') }}
          //- .vendors-subheader.filters-row
          //-   ods-input-search(
          //-     size='hecto'
          //-     outlined
          //-     placeholder='Buscar'
          //-     @input='vendorSearch'
          //-     )
          //-   ods-button(
          //-     size="medium"
          //-     @click="showVendorsMenu") {{ this.$t('commerceInfo.SellerRegistration') }}

          vendors-table.ods-mt-6

      ods-tab-pane(label='Financiación' name='1007' v-if="tabVisible(1000, 1007)" lazy)
        ods-module.commerce-info__module--left-tabs
          ods-tabs(
            tab-position='left'
            class="left-tabs"
            v-model='activeFinancingTab'
            ref="tabFinancing"
            )
            ods-tab-pane(label='Solicitudes' name="1017" v-if="tabVisible(1000, 1007, 1017)" lazy)
              p.tp-m-deci.ods-mb-6 {{ this.$t('commerceInfo.listRequests') }}
              //- .filters-row
              //-   ods-input-search(
              //-     size='hecto'
              //-     outlined
              //-     placeholder='Buscar'
              //-     @input='requestSearch')

              request-table.ods-mt-6

            ods-tab-pane(label='Financiaciones' name="1027" v-if="tabVisible(1000, 1007, 1027)" lazy)
              p.tp-m-deci.ods-mb-6 {{ this.$t('commerceInfo.listFinancing') }}
              //- .filters-row
              //-   ods-input-search(
              //-     size='hecto'
              //-     outlined
              //-     placeholder='Buscar'
              //-     @input='financingSearch')

              financing-table.ods-mt-6(:comercio="commerceData")

      ods-tab-pane(label='QR' name='1008' v-if="tabVisible(1000, 1008)" lazy)
        ods-module.commerce-info__module--left-tabs
          ods-tabs(
            tab-position='left'
            class="left-tabs"
            v-model='activeQRTabs'
            ref="tabQR"
            )
            ods-tab-pane(label='Usuarios' name="1018" v-if="tabVisible(1000, 1008, 1018)" lazy)
              span(slot="label") {{ this.$t('commerceInfo.users') }}
                ods-badge.ods-ml-2(:value='totalUsersBadge' type='secondary')
              p.tp-m-deci.ods-mb-6 {{ this.$t('commerceInfo.staff') }}

              users-table(:comercio="commerceData" @totalUsers="totalUsers")

            ods-tab-pane(label='Terminales QR' name="1028" v-if="tabVisible(1000, 1008, 1028)" lazy)
              span(slot="label") {{ this.$t('commerceInfo.terminals') }}
                ods-badge.ods-ml-2(:value='totalTPVBadge' type='secondary')
              p.tp-m-deci.ods-mb-6 {{ this.$t('commerceInfo.commerceTPV') }}

              terminales-table(:tpv="true" :codcomercio="commerceData.codcom" :desdescomercio="commerceData.descomercio" @totalTPV="totalTPV")

            ods-tab-pane(label='Movimientos' name="1038" v-if="tabVisible(1000, 1008, 1038)" lazy)
              span(slot="label") {{ this.$t('commerceInfo.movements') }}
                ods-badge.ods-ml-2(:value='totalMovementsBadge' type='secondary')
              //- ods-input-search.ods-mt-3(
              //-   size='hecto'
              //-   outlined
              //-   placeholder='Buscar'
              //-   @input='movementsSearch')

              movements-table.ods-mt-6(:commerce="commerceData" @totalMovements="totalMovements")

    el-drawer(
      :title="vendorTitle"
      :visible.sync="showDetailPage"
      direction="rtl",
      :wrapperClosable="false"
      :append-to-body="false"
      size="60%"
      :class="vendorFormType")
      ods-scrollbar(viewClass="view-class" wrapClass="wrap-class")
        //- ods-form.vendor-form(
        //-   v-if="formToDisplay === 'vendor'"
        //-   label-position='top'
        //-   :model='vendorFormData'
        //-   ref='ticketForm'
        //-   :rules="formrules"
        //-   :disabled = "vendorFormType === 'show'"
        //-   :show-message="showMessage"
        //-   :validate-on-rule-change="validateOnRuleChange"
        //-   )
        //-   template(v-if="vendorFormType !== 'add'")
        //-     h2.form-section.tp-r-deci {{ this.$t('commerceInfo.dataSeller') }}
        //-     .form-grid
        //-       ods-form-item(label="Código vendedor")
        //-         ods-input(
        //-           v-model="vendorFormData.codvends"
        //-           :disabled="vendorFormType === 'edit'"
        //-           )
        //-   h2.form-section.tp-r-deci {{ this.$t('commerceInfo.ContactInformation') }}
        //-   .form-grid
        //-     ods-form-item(label="Nombre" prop="nomvends")
        //-       ods-input(v-model="vendorFormData.nomvends")
        //-     ods-form-item(label="Apellidos" prop="apellvends" )
        //-       ods-input(v-model="vendorFormData.apellvends")
        //-     ods-form-item(label="Tipo documento" prop="tipdocvs")
        //-       ods-input(
        //-         v-model="vendorFormData.tipdocvs"
        //-         :disabled="vendorFormType === 'edit'"
        //-         )
        //-     ods-form-item(label="Número documento" prop="numdocvs")
        //-       ods-input(
        //-         v-model="vendorFormData.numdocvs"
        //-         :disabled="vendorFormType === 'edit'"
        //-         )
        //-     ods-form-item(label="Teléfono" prop="tlfocomer")
        //-       ods-input(v-model="vendorFormData.tlfocomer")
        //-     ods-form-item(label="Correo Electrónico" prop="mailcomer")
        //-       ods-input(v-model="vendorFormData.mailcomer")

        //-   h2.form-section.tp-r-deci {{ this.$t('commerceInfo.address') }}
        //-   .form-grid
        //-     //- ods-form-item(label="Tipo de vía")
        //-     //-   ods-input(v-model="vendorFormData.road")
        //-     ods-form-item(label="Dirección" prop="direven")
        //-       ods-input(v-model="vendorFormData.direven")
        //-     ods-form-item(label="Población" prop="poblvend")
        //-       ods-input(v-model="vendorFormData.poblvend")
        //-     ods-form-item(label="Código postal" prop="cpvend")
        //-       ods-input(v-model="vendorFormData.cpvend")
        //-     ods-form-item(label="Provincia" prop="provvend")
        //-       ods-input(v-model="vendorFormData.provvend")

        //-   h2.form-section.tp-r-deci {{ this.$t('commerceInfo.bankData') }}
        //-   .form-grid
        //-     ods-form-item(label="IBAN" prop="iban")
        //-       ods-input(v-model="vendorFormData.iban")
        //-     ods-form-item(label="Cuenta de cargo" prop="ctacargo")
        //-       ods-input(v-model="vendorFormData.ctacargo")
        //-     ods-form-item(label="Moneda" prop="clamon")
        //-       ods-input(
        //-         v-model="vendorFormData.clamon"
        //-         :disabled="vendorFormType === 'edit'"
        //-         )

        //-   ods-button(@click="addVendor" v-if="vendorFormType === 'add'") {{ this.$t('login.submitButton') }}
        //-   ods-button(@click="modifyVendor" v-if="vendorFormType === 'edit'") {{ this.$t('commerceInfo.modifyData') }}
        //- ods-button(@click="editVendor(false)" v-if="vendorFormType === 'show'") {{ this.$t('commerceInfo.editData') }}

        ods-form.vendor-form(
          v-if="formToDisplay === 'QRUsers'"
          label-position='top'
          :model='QRUsersFormData'
          ref='QRUsers'
          :rules="formrulesQRUsers"
          :disabled = "vendorFormType === 'show'"
          )
          .form-grid
            ods-form-item(label="Usuario" prop="usuario" required)
              ods-input(v-model="QRUsersFormData.usuario")
            ods-form-item(label="Perfil" prop="codperfil" required)
              ods-select(
                v-model="QRUsersFormData.codperfil"
                @change="QRUsersPerfilChange")
                ods-option(
                  v-for='item in QRprofiles'
                  :key='item.value'
                  :label='item.descrip'
                  :value='item.valor')
          .form-grid
            ods-form-item(label="Holding" prop="holding")
              ods-input(v-model="QRUsersFormData.holding")
            ods-form-item(label="Cadena" prop="codcadena")
              ods-input(v-model="QRUsersFormData.codcadena")
            ods-form-item(label="Comercio" prop="codcom")
              ods-input(v-model="QRUsersFormData.codcom")
            ods-form-item(label="Nombre" prop="nombre" required)
              ods-input(v-model="QRUsersFormData.nombre")
            ods-form-item(label="Primer apellido" prop="apelli1" required)
              ods-input(v-model="QRUsersFormData.apelli1")
            ods-form-item(label="Segundo apellido" prop="apelli2" required)
              ods-input(v-model="QRUsersFormData.apelli2")
            ods-form-item(label="Email" prop="email" required)
              ods-input(v-model="QRUsersFormData.email")
            ods-form-item(label="Telefono móvil" prop="tel_movil" required)
              ods-input(v-model="QRUsersFormData.tel_movil")

          ods-button(@click="addQr" v-if="vendorFormType === 'add'") {{ this.$t('login.submitButton') }}

        //- terminal-detail(:data="terminalInfo" v-if="formToDisplay==='terminalDetail'")

    ods-dialog(
      :visible.sync="message"
      :append-to-body="true"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :show-close="true"
      center
      width="420px")
      div
        img(
          :src="require('@/assets/icons/vendors.png')"
          alt="Vendors"
          class="dialog__img"
        )
        p.dialog__msg {{ this.dialogMessage }}
      .dialog-footer(slot='footer')
        ods-button(@click='handleDialogClose') {{ this.$t('commerceInfo.accept') }}

    ods-dialog(
      :visible.sync="showExport"
      :append-to-body="true"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :show-close="true"
      title="Exportar"
      width="440px")
      div
        p.ods-mb-4 Selecciona el formato para exportar
        ods-radio-group(v-model="radioExport").flex-container.space-around
          ods-radio(label="pdf") PDF
          ods-radio(label="excel") Excel
          ods-radio(label="csv") Csv
      div(slot='footer')
        ods-button(type="text" @click="showExport = false") Cancelar
        ods-button(@click="") Exportar

</template>

<script>
// import tariff from '@/mocks/tariff.json'
// import tarifRappel from '@/mocks/tarifRappel.json'

import TariffTable from '@/components/CommerceInfo/TariffTable'
import BillingTable from '@/components/CommerceInfo/BillingTable'
import CommissionsTable from '@/components/CommerceInfo/CommissionsTable'

import RappelTable from '@/components/CommerceInfo/RappelTable'
import CardtypeTable from '@/components/CommerceInfo/CardtypeTable'
import ProducttypeTable from '@/components/CommerceInfo/ProducttypeTable'
import VendorsTable from '@/components/CommerceInfo/VendorsTable'
import RequestTable from '@/components/CommerceInfo/RequestTable'
import FinancingTable from '@/components/CommerceInfo/FinancingTable'
import UsersTable from '@/components/CommerceInfo/UsersTable'
import TpvTable from '@/components/CommerceInfo/TpvTable'
import MovementsTable from '@/components/CommerceInfo/MovementsTable'
import ReceiptsTable from '@/components/CommerceInfo/ReceiptsTable'
import VentanaUsuario from '@/components/dialogs/VentanaUsuario'
import VentanaTerminal from '@/components/dialogs/VentanaTerminal'
import UsuariosTable from '@/components/usuarios/UsuariosPorComercioTable'
import TerminalesTable from '@/components/cadena/TerminalesTable'
import RateRappelTable from '@/components/CommerceInfo/RateRappelTable'
import TerminalsInquiriesTable from '@/components/CommerceInfo/TerminalsInquiriesTable'
// import TerminalDetail from '@/components/CommerceInfo/TerminalDetail'

import { mapGetters } from 'vuex'

export default {
  name: 'CommerceInfo',

  components: {
    TariffTable,
    BillingTable,
    CommissionsTable,
    RappelTable,
    CardtypeTable,
    ProducttypeTable,
    VendorsTable,
    RequestTable,
    FinancingTable,
    UsersTable,
    TpvTable,
    MovementsTable,
    VentanaUsuario,
    VentanaTerminal,
    TerminalesTable,
    UsuariosTable,
    ReceiptsTable,
    RateRappelTable,
    TerminalsInquiriesTable
    // TerminalDetail
  },

  data () {
    return {
      message: false,
      dialogMessage: '',
      activeTab: null,
      activeTariffTab: null,
      activeInquiriesTab: null,
      activeQRTabs: null,
      // tariffSearch: '',
      // searchText: '',
      // tariffData: [],
      // billingData: [],
      // commissionsData: [],
      // rappelData: [],
      // rateRappelData: [],
      // terminalsData: [],
      // newTariffData: [],
      // newBillingData: [],
      // newCommissionsData: [],
      // newRappelData: [],
      // newRateRappelData: [],
      // newTerminalsData: [],
      // requestData: [],
      // newRequestData: [],
      // financingData: [],
      // newfinancingData: [],
      // newTariffRappel: [],
      // receiptsData: [],
      // newReceiptsData: [],
      // mock3: tarifRappel,
      // cardsData: [],
      // newCardsData: [],
      // vendorsData: [],
      // newVendorsData: [],
      // productTypeData: [],
      // newProductTypeData: [],
      // usersData: [],
      // newUsersData: [],
      totalUsersBadge: 0,
      // TPVData: [],
      // TPVlist: [],
      // newTPVData: [],
      totalTPVBadge: 0,
      // movementsData: [],
      // newMovementsData: [],
      totalMovementsBadge: 0,
      // data: tariff,
      showDetailPage: false,
      formToDisplay: 'vendor',
      QRprofiles: [],
      vendorFormData: {},
      QRUsersFormData: {},
      activeFinancingTab: null,
      commerceData: {},
      vendorFormType: 'add',
      vendorTitle: 'Nuevo vendedor',
      // rowSelectedCount: 0,
      // dateSearch: null,
      // dateSearchBilling: null,
      // dateSearchCommissions: null,
      // dateSearchRappel: null,
      showExport: false,
      radioExport: 'pdf',
      // terminalInfo: {},
      // formrules: {
      //   nomvends: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
      //   apellvends: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
      //   tipdocvs: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
      //   numdocvs: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
      //   tlfocomer: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
      //   mailcomer: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
      //   direven: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
      //   poblvend: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
      //   cpvend: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
      //   provvend: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
      //   iban: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
      //   ctacargo: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }]
      // },
      formrulesQRUsers: {
        usuario: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        perfil: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        nombre: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        apelli1: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        apelli2: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        email: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        tel_movil: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }]
      },
      showMessage: true,
      validateOnRuleChange: true
    }
  },

  created () {
    if (this.$route.params.comercio) {
      this.commerceData = this.$route.params.comercio
      sessionStorage.setItem('descComercio', this.commerceData.descomercio)
      sessionStorage.setItem('descCadena', this.commerceData.descadena)
      sessionStorage.setItem('comercio', JSON.stringify(this.commerceData))
    } else {
      if (sessionStorage.getItem('comercio')) {
        this.commerceData = JSON.parse(sessionStorage.getItem('comercio'))
        this.$route.params.comercio = JSON.parse(sessionStorage.getItem('comercio'))
      } else {
        this.$store.commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      }
    }
    // set breadrumbs chain and commerce name
    this.$route.params.commerce = sessionStorage.getItem('descComercio')
    this.$route.params.chain = sessionStorage.getItem('descCadena')
  },

  async mounted () {
    this.setActiveTab()

    // if (this.getActiveInquiriesTab !== null) {
    //   this.activeInquiriesTab = this.getActiveInquiriesTab
    // } else {
    //   this.activeInquiriesTab = this.$refs.tabInquiries ? this.$refs.tabInquiries.panes[0].name : null
    // }
    // this.activeTariffTab = this.$refs.tabTariff ? this.$refs.tabTariff.panes[0].name : null
    // this.activeQRTabs = this.$refs.tabQR ? this.$refs.tabQR.panes[0].name : null
    // this.activeFinancingTab = this.$refs.tabFinancing ? this.$refs.tabFinancing.panes[0].name : null

    // const data = {
    //   producto: this.$route.params.comercio.producto,
    //   subproducto: this.$route.params.comercio.subproducto,
    //   conprod: this.$route.params.comercio.conprod.toString(),
    //   codcom: this.$route.params.comercio.codcom
    // }

    // borrar esto es un mock
    // this.newTariffRappel = this.mock3.tarifRappel

    // Tarifas generales - listado
    // await this.$store.dispatch('getGeneralTariff', data)
    //   .then((res) => {
    //     if (!(!res || (res && res.error === true))) {
    //       this.tariffData = res
    //       this.newTariffData = this.tariffData
    //       // las siguientes variables son provisionales, cambiar la asignacion cuando tengamos el servicio
    //       this.terminalsData = res
    //       this.newTerminalsData = this.terminalsData
    //       // fin de datos provisionales hasta tener servicios
    //       // Tarifas de tipos de tarjetas - listado
    //     }
    //   })
    // await this.$store.dispatch('getCardsTariff', data)
    //   .then((res) => {
    //     this.cardsData = res
    //     this.newCardsData = this.cardsData
    //     // Solicitudes - listado
    // await this.$store.dispatch('getRequests', data)
    //   .then((res) => {
    //     this.requestData = res
    //     this.newRequestData = this.requestData
    // Vendedores - Listado
    // this.$store.dispatch('getVendors', data)
    //   .then((res) => {
    //     this.vendorsData = res
    //     this.newVendorsData = this.vendorsData
    // Tarifas de tipos de préstamos - listado
    // this.$store.dispatch('getLoansTariff', data)
    //   .then((res) => {
    //     this.productTypeData = res
    //     this.newProductTypeData = this.productTypeData
    // Listado de usuarios por comercio
    // listUsersQR - Se integrará más adelante
    // await this.$store.dispatch('listUsersQR', { codcom: this.commerceData.codcom })
    //   .then((res) => {
    //     this.usersData = Array.isArray(res.registros) ? res.registros : [res.registros]
    //     this.newUsersData = this.usersData
    //     this.totalUsers = res.registros.length
    // Listado de TPVs (terminales)
    // this.$store.dispatch('listTpv', { codcom: this.commerceData.codcom })
    //   .then((res) => {
    // this.TPVData = res
    // this.newTPVData = this.TPVData
    // this.totalTPV = res.length
    // Listado de TPVs (terminales)
    // this.$store.dispatch('listMovimientos', { codcom: this.commerceData.codcom })
    //   .then((res) => {
    //     this.movementsData = res
    //     this.newMovementsData = this.movementsData
    //     this.totalMovements = res.length
    // Listado de perfiles QR
    // this.$store.dispatch('listProfile')
    //   .then((res) => {
    //     this.QRprofiles = res
    // Listado de Terminales TPV
    // this.$store.dispatch('listVisorTPVS', { codcom: this.commerceData.codcom })
    //   .then((res) => {
    // this.TPVlist = res
    // Listado de Consultas - Facturación
    // this.$store.dispatch('listBilling', { codcom: this.commerceData.codcom })
    //   .then((res) => {
    //     this.billingData = res
    //     this.newBillingData = this.billingData
    // Listado de Financiación - Financiaciones
    // this.$store.dispatch('listFinancing', { codcom: this.commerceData.codcom })
    //   .then((res) => {
    //     this.financingData = res
    //     this.newfinancingData = this.financingData
    // Listado Tipo Rappel
    // this.$store.dispatch('typeRappel', { tipoestrap: 'C', codcom: this.commerceData.codcom })
    //   .then((res) => {
    //     this.rateRappelData = res
    //     this.newRateRappelData = this.rateRappelData
    // Listado Consultas - Comisiones
    // this.$store.dispatch('listCommissions', { codcom: this.commerceData.codcom })
    //   .then((res) => {
    //     this.commissionsData = res
    //     this.newCommissionsData = this.commissionsData
    // Listado Consultas - Rappel
    // this.$store.dispatch('listRappel', { tipoestrap: 'C', codestrap: this.commerceData.codcom })
    //   .then((res) => {
    //     this.rappelData = res
    //     this.newRappelData = this.rappelData
    // Listado Recibos
    // this.$store.dispatch('listReceipts', { codproceso: 3, codcom: this.commerceData.codcom })
    //   .then((res) => {
    //     this.receiptsData = res
    //     this.newReceiptsData = this.receiptsData
    //   })
    // })
  // })
  // })
  // })
  // })
  // })
  // })
  // })
  // })
  // })
  // })
  // })
  // })
  // })
  },

  destroyed () {
    if (!(this.$route.name === 'FacturacionTable' || this.$route.name === 'RecibosTable')) {
      this.activeTab = null
      this.activeTariffTab = null
      this.activeInquiriesTab = null
      this.activeQRTabs = null
      this.$store.dispatch('setActiveInquiriesTab', this.activeInquiriesTab)
      this.$store.dispatch('setActiveTab', this.activeTab)
    }
  },

  computed: {
    ...mapGetters({
      getNavPermissions: 'getNavPermissions',
      getActiveTab: 'getActiveTab',
      getActiveInquiriesTab: 'getActiveInquiriesTab'
    })

    // rowSelectedTitle () {
    //   const msg = this.rowSelectedCount === 0 ? '' : this.rowSelectedCount > 1 ? 'ELEMENTOS SELECCIONADOS' : 'ELEMENTO SELECCIONADO'
    //   return this.rowSelectedCount > 0 ? `${this.rowSelectedCount} ${msg}` : ''
    // }

    // clearButtonVisibility () {
    //   return this.dateSearch
    // },

    // clearBillingButtonVisibility () {
    //   return this.dateSearchBilling
    // },

    // clearCommissionsButtonVisibility () {
    //   return this.dateSearchCommissions
    // },

    // clearRappelButtonVisibility () {
    //   return this.dateSearchRappel
    // }
  },

  watch: {
    // showDetailPage (val) {
    //   if (this.$refs.ticketForm) {
    //     this.$refs.ticketForm.clearValidate()
    //   }
    // },

    activeTab (newVal, oldVal) {
      this.$store.dispatch('setActiveTab', newVal)
      this.setActiveSubTabs(newVal)
      this.resetDefaultTabs(oldVal)
      this.resetDateFilterChangeTab(newVal)
    },

    activeInquiriesTab (newVal, oldVal) {
      if (newVal !== '0') {
        this.$store.dispatch('setActiveInquiriesTab', newVal)
        this.resetDefaultInquiriesSubTabs(oldVal)
        this.resetDateFilterChangeTab(this.activeTab, newVal)
      }
    }
  },

  methods: {
    setActiveTab () {
      if (this.getActiveTab !== null) {
        this.activeTab = this.getActiveTab
      } else {
        if (this.$refs.tabs) {
          this.activeTab = this.$refs.tabs.panes.length > 0 ? this.$refs.tabs.panes[0].name : null
        }
      }
    },

    resetDateFilterChangeTab (tabName, subtabName) {
      this.$nextTick(() => {
        this.$refs.tabs.panes.forEach(tab => {
          if (tab.name === tabName) {
            if (tab.$children) {
              if (tab.$children[0].$children[0].panes) {
                tab.$children[0].$children[0].panes.forEach(subtab => {
                  if (!subtabName) {
                    this.clearDate(subtab)
                  } else {
                    if (subtab.name === subtabName) {
                      this.clearDate(subtab)
                    }
                  }
                })
              }
            }
          }
        })
      })
    },

    clearDate (subtab) {
      if (subtab.$children.length > 0) {
        subtab.$children[0].$children.forEach(child => {
          if (child.constructor.options.name === 'FilterTable') {
            if (child.dateSearch) {
              child.clearDateSearch()
            }
          }
        })
      }
    },

    tabVisible (root, parent, children) {
      const tree = this.getNavPermissions.find(el => el.idopcion === root)
      if (tree) {
        const tab = tree.registros.find(el => el.idopcion === parent)
        if (!children) {
          if (tab) {
            return !tab.indpermiso
          }
        } else {
          if (tab.registros) {
            const subtab = tab.registros.find(el => el.idopcion === children)
            if (subtab) {
              return !subtab.indpermiso
            }
          } else {
            return true
          }
        }
      }
    },

    resetDefaultTabs (val) {
      switch (val) {
        case '1004':
          this.resetDefaultInquiriesSubTabs(this.activeInquiriesTab)
          break
      }
    },

    resetDefaultInquiriesSubTabs (val) {
      switch (val) {
        case '1041':
          // if (this.dateSearchBilling) this.clearDateSearchBilling()
          break
        case '1042':
          // if (this.dateSearchCommissions) this.clearDateSearchCommissions()
          break
        case '1043':
          // if (this.dateSearchRappel) this.clearDateSearchRappel()
          break
      }
    },

    setActiveSubTabs (val) {
      this.$nextTick(() => {
        switch (val) {
          case '1003':
            this.activeTariffTab = this.$refs.tabTariff ? this.$refs.tabTariff.panes[0].name : null
            break
          case '1004':
            if (this.getActiveInquiriesTab !== null) {
              this.activeInquiriesTab = this.getActiveInquiriesTab
            } else {
              this.activeInquiriesTab = this.$refs.tabInquiries ? this.$refs.tabInquiries.panes[0].name.toString() : null
            }
            break
          case '1007':
            this.activeFinancingTab = this.$refs.tabFinancing ? this.$refs.tabFinancing.panes[0].name : null
            break
          case '1008':
            this.activeQRTabs = this.$refs.tabQR ? this.$refs.tabQR.panes[0].name : null
            break
        }
      })
    },

    totalTPV (val) {
      this.totalTPVBadge = val
    },

    totalUsers (val) {
      this.totalUsersBadge = val
    },

    totalMovements (val) {
      this.totalMovementsBadge = val
    },

    // rowSelectedListener (val) {
    //   this.rowSelectedCount = val
    // },

    // rowSelectedListenerReci (val) {
    //   this.rowSelectedCount = val
    // },

    // clearDateSearch () {
    //   this.dateSearch = null
    // },

    // refreshVendorsList () {
    //   this.$store.dispatch('getVendors', { codcom: this.commerceData.codcom })
    //     .then((res) => {
    //       this.vendorsData = res
    //       this.newVendorsData = this.vendorsData
    //     })
    // },

    handleDialogClose () {
      this.message = false
    },

    // tariffDataSearch (text) {
    //   this.newTariffData = this.tariffData.filter((res) => {
    //     return res.desconeco.toLowerCase().includes(text.toLowerCase())
    //   })
    // },

    // billingDataSearch (text) {
    //   this.newBillingData = this.billingData.filter((res) => {
    //     return res.destiporem.toLowerCase().includes(text.toLowerCase())
    //   })
    // },

    // commissionsDataSearch (text) {
    //   this.newCommissionsData = this.commissionsData.filter((res) => {
    //     return res.descodconeco.toLowerCase().includes(text.toLowerCase()) ||
    //       res.impconcep.toString().replace('.', ',').toLowerCase().includes(text.toLowerCase())
    //   })
    // },

    // rappelDataSearch (text) {
    //   this.newRappelData = this.rappelData.filter((res) => {
    //     return res.desrappel.toLowerCase().includes(text.toLowerCase()) ||
    //       res.desindsitrap.toLowerCase().includes(text.toLowerCase())
    //   })
    // },

    // terminalsDataSearch (text) {
    //   this.newTerminalsData = this.terminalsData.filter((res) => {
    //     return res.desconeco.toLowerCase().includes(text.toLowerCase())
    //   })
    // },

    // cardtypeSearch (text) {
    //   this.newCardsData = this.cardsData.filter((res) => {
    //     return res.destiptred.toLowerCase().includes(text.toLowerCase()) ||
    //       res.desconeco.toLowerCase().includes(text.toLowerCase())
    //   })
    // },

    // productTypeSearch (text) {
    //   this.newProductTypeData = this.productTypeData.filter((res) => {
    //     return res.codtipc.toLowerCase().includes(text.toLowerCase()) ||
    //       res.destipc.toLowerCase().includes(text.toLowerCase())
    //   })
    // },

    // rateRappelSearch (text) {
    //   this.newRateRappelData = this.rateRappelData.filter((res) => {
    //     return res.desrappel.toLowerCase().includes(text.toLowerCase())
    //   })
    // },

    // vendorSearch (text) {
    //   this.newVendorsData = this.vendorsData.filter((res) => {
    //     return res.apellvends.toLowerCase().includes(text.toLowerCase()) ||
    //       res.nomvends.toLowerCase().includes(text.toLowerCase()) ||
    //       res.numdocvs.toLowerCase().includes(text.toLowerCase()) ||
    //       res.codvends.toLowerCase().includes(text.toLowerCase())
    //   })
    // },

    // requestSearch (text) {
    //   this.newRequestData = this.requestData.filter((res) => {
    //     return res.numdoc.toLowerCase().includes(text.toLowerCase()) ||
    //       res.nombre.toLowerCase().includes(text.toLowerCase()) ||
    //       res.desestsolicitud.toLowerCase().includes(text.toLowerCase())
    //   })
    // },

    // financingSearch (text) {
    //   this.newfinancingData = this.financingData.filter((res) => {
    //     return res.destipc.toLowerCase().includes(text.toLowerCase())
    //   })
    // },

    // receiptsSearch (text) {
    //   this.newReceiptsData = this.receiptsData.filter((res) => {
    //     return res.fecemimov.valueDate.toLowerCase().includes(text.toLowerCase()) ||
    //       this.$options.filters.formatAccount(res.iban, res.ctacargo).replace(/\s/g, '').toLowerCase().includes(text.replace(/\s/g, '').toLowerCase()) ||
    //       res.imprec.toString().replace('.', ',').toLowerCase().includes(text.toLowerCase()) ||
    //       res.descodproced.toLowerCase().includes(text.toLowerCase()) ||
    //       res.dessituarec.toLowerCase().includes(text.toLowerCase())
    //   })
    // },

    // userSearch (text) {
    //   this.newUsersData = this.usersData.filter((res) => {
    //     return res.desperfil.toLowerCase().includes(text.toLowerCase()) ||
    //       res.nombre.toLowerCase().includes(text.toLowerCase()) ||
    //       res.apelli1.toLowerCase().includes(text.toLowerCase()) ||
    //       res.apelli2.toLowerCase().includes(text.toLowerCase()) ||
    //       res.usuario.toLowerCase().includes(text.toLowerCase())
    //   })
    // },

    // tpvSearch (text) {
    //   this.newTPVData = this.TPVData.filter((res) => {
    //     return res.codterm.toLowerCase().includes(text.toLowerCase()) ||
    //       res.texto.toLowerCase().includes(text.toLowerCase()) ||
    //       res.descripsit.toLowerCase().includes(text.toLowerCase()) ||
    //       res.usuario.toLowerCase().includes(text.toLowerCase())
    //   })
    // },

    // movementsSearch (text) {
    //   this.newMovementsData = this.movementsData.filter((res) => {
    //     return res.desrechazoqr.toLowerCase().includes(text.toLowerCase()) ||
    //       res.idpan.toLowerCase().includes(text.toLowerCase()) ||
    //       res.destpv.toLowerCase().includes(text.toLowerCase())
    //   })
    // },

    // billingFilterButton () {
    //   const data = {
    //     codcom: this.commerceData.codcom,
    //     fecdesde: {
    //       valueDate: this.$options.filters.formatDate(this.dateSearchBilling[0])
    //     },
    //     fechasta: {
    //       valueDate: this.$options.filters.formatDate(this.dateSearchBilling[1])
    //     }
    //   }
    //   this.$store.dispatch('listBilling', data)
    //     .then((res) => {
    //       this.billingData = res
    //       this.newBillingData = this.billingData
    //     })
    // },

    // commissionsFilterButton () {
    //   const data = {
    //     codcom: this.commerceData.codcom,
    //     fecdesde: {
    //       valueDate: this.$options.filters.formatDate(this.dateSearchCommissions[0])
    //     },
    //     fechasta: {
    //       valueDate: this.$options.filters.formatDate(this.dateSearchCommissions[1])
    //     }
    //   }
    //   this.$store.dispatch('listCommissions', data)
    //     .then((res) => {
    //       this.commissionsData = res
    //       this.newCommissionsData = this.commissionsData
    //     })
    // },

    // rappelFilterButton () {
    //   const data = {
    //     tipoestrap: 'C',
    //     codestrap: this.commerceData.codcom,
    //     fecdesde: {
    //       valueDate: this.$options.filters.formatDate(this.dateSearchRappel[0])
    //     },
    //     fechasta: {
    //       valueDate: this.$options.filters.formatDate(this.dateSearchRappel[1])
    //     }
    //   }
    //   this.$store.dispatch('listRappel', data)
    //     .then((res) => {
    //       this.rappelData = res
    //       this.newRappelData = this.rappelData
    //     })
    // },

    // clearDateSearchBilling () {
    //   this.dateSearchBilling = null
    //   this.$store.dispatch('listBilling', { codcom: this.commerceData.codcom })
    //     .then((res) => {
    //       this.billingData = res
    //       this.newBillingData = this.billingData
    //     })
    // },

    // clearDateSearchCommissions () {
    //   this.dateSearchCommissions = null
    //   this.$store.dispatch('listCommissions', { codcom: this.commerceData.codcom })
    //     .then((res) => {
    //       this.commissionsData = res
    //       this.newCommissionsData = this.commissionsData
    //     })
    // },

    // clearDateSearchRappel () {
    //   this.dateSearchRappel = null
    //   this.$store.dispatch('listRappel', { tipoestrap: 'C', codestrap: this.commerceData.codcom })
    //     .then((res) => {
    //       this.rappelData = res
    //       this.newRappelData = this.rappelData
    //     })
    // },

    // showVendorsMenu () {
    //   this.formToDisplay = 'vendor'
    //   this.vendorFormType = 'add'
    //   this.vendorFormData = {}
    //   this.showDetailPage = true
    //   this.vendorTitle = 'Nuevo vendedor'
    //   // this.$refs.ticketForm.resetFields()
    // },

    showQRMenu () {
      this.formToDisplay = 'QRUsers'
      this.vendorFormType = 'add'
      this.showDetailPage = true
      this.vendorTitle = 'Alta de usuarios'
    }

    // showTerminalDetail (val) {
    //   this.terminalInfo = val
    //   this.formToDisplay = 'terminalDetail'
    //   this.vendorFormType = 'add'
    //   this.showDetailPage = true
    //   this.vendorTitle = 'Detalle Terminal'
    // },

    // openDetailTerminal (val) {
    //   this.showTerminalDetail(val)
    // },

    // resetQRTable () {
    //   // listUsersQR
    //   this.$store.dispatch('listUsersQR', { codcom: this.commerceData.codcom })
    //     .then((res) => {
    //       this.usersData = Array.isArray(res.registros) ? res.registros : [res.registros]
    //       this.newUsersData = this.usersData
    //       this.totalUsers = res.registros.length
    //     })
    // },

    // resetTpvTable () {
    //   // seguramente se pueda borrar ya que no se llama en ningun sitio, revisar
    //   this.$store.dispatch('listTpv', { codcom: this.commerceData.codcom })
    //     .then((res) => {
    //       this.TPVData = res
    //       this.newTPVData = this.TPVData
    //       this.totalUsers = res.length
    //     })
    // },

    // addVendor () {
    //   this.$refs.ticketForm.validate((valid) => {
    //     if (valid) {
    //       const today = new Date()
    //       this.vendorFormData.fecalta = {
    //         anno: today.getFullYear(),
    //         dia: today.getDate(),
    //         format: 'dd-MM-yyyy',
    //         mes: today.getMonth(),
    //         nombreDia: '',
    //         nombreMes: '',
    //         valueDate: today.getDate() + '-' + today.getMonth() + '-' + today.getFullYear()
    //       }
    //       this.vendorFormData.codcom = this.$route.params.comercio.codcom
    //       this.$store.dispatch('addVendor', this.vendorFormData)
    //         .then((res) => {
    //           if (res) {
    //             if (Array.isArray(res)) {
    //               this.$refs.ticketForm.resetFields()
    //               this.showDetailPage = false
    //               this.dialogMessage = 'Vendedor añadido con éxito'
    //               this.message = true
    //               this.refreshVendorsList()
    //             } else {
    //               this.errorMsg = res
    //             }
    //           }
    //         })
    //     } else {
    //       return false
    //     }
    //   })
    // },

    // editVendor (vendorId) {
    //   if (vendorId) this.vendorFormData = this.vendorsData.filter((vendor) => vendor.codvends === vendorId)[0]
    //   this.formToDisplay = 'vendor'
    //   this.vendorFormType = 'edit'
    //   this.showDetailPage = true
    //   this.vendorTitle = 'Editar vendedor'
    // },

    // modifyVendor (vendorId) {
    //   this.$refs.ticketForm.validate((valid) => {
    //     if (valid) {
    //       const vendor = this.vendorsData.filter((vendor) => vendor.codvends === this.vendorFormData.codvends)[0]
    //       this.vendorFormData.codcom = this.$route.params.comercio.codcom
    //       this.vendorFormData.contcur = vendor.contcur
    //       this.showDetailPage = false
    //       this.$store.dispatch('modifyVendor', this.vendorFormData)
    //         .then((res) => {
    //           if (res) {
    //             this.dialogMessage = 'Vendedor modificado con éxito'
    //             this.message = true
    //             this.refreshVendorsList()
    //           }
    //         })
    //     } else {
    //       return false
    //     }
    //   })
    // },

    // showVendorDetails (vendorId) {
    //   this.vendorFormData = this.vendorsData.filter((vendor) => vendor.codvends === vendorId)[0]
    //   this.formToDisplay = 'vendor'
    //   this.vendorFormType = 'show'
    //   this.showDetailPage = true
    //   this.vendorTitle = 'Detalle vendedor'
    // },

    // deleteVendor (vendorId) {
    //   this.showDetailPage = false
    //   const vendor = this.vendorsData.filter((vendor) => vendor.codvends === vendorId)[0]
    //   const today = new Date()
    //   vendor.fecbaja = {
    //     anno: today.getFullYear(),
    //     dia: today.getDate(),
    //     format: 'dd-MM-yyyy',
    //     mes: today.getMonth(),
    //     nombreDia: '',
    //     nombreMes: '',
    //     valueDate: today.getDate() + '-' + today.getMonth() + '-' + today.getFullYear()
    //   }
    //   const h = this.$createElement
    //   this.$confirm(h('div', { class: { deletemessage: true } }, [
    //     h('p', { class: { text: true } }, 'Se va a eliminar el siguiente Vendedor:'),
    //     h('p', { class: { data: true } }, 'Nº de empleado: ' + vendor.codvends),
    //     h('p', { class: { data: true } }, 'Nombre: ' + vendor.nomvends),
    //     h('p', { class: { data: true } }, 'Apellidos: ' + vendor.apellvends),
    //     h('p', { class: { text: true } }, '¿Está seguro de que desea eliminar de forma permanente este vendedor?')
    //   ]), 'Warning', {
    //     title: 'Confirmar eliminación permanente',
    //     confirmButtonText: 'Eliminar',
    //     cancelButtonText: 'Cancelar',
    //     type: 'warning'
    //   }).then(() => {
    //     this.$store.dispatch('deleteVendor', vendor)
    //       .then((res) => {
    //         if (res) {
    //           this.showDetailPage = false
    //           this.dialogMessage = 'Vendedor eliminado con éxito'
    //           this.message = true
    //           this.refreshVendorsList()
    //         }
    //       })
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: 'eliminación de vendedor cancelada'
    //     })
    //   })
    // },

    // deleteQr (userId) {
    //   this.showDetailPage = false
    //   const user = this.usersData.filter((user) => user.registro_Numero === userId)[0]
    //   const h = this.$createElement
    //   this.$confirm(h('div', { class: { deletemessage: true } }, [
    //     h('p', { class: { text: true } }, 'Se va a eliminar el siguiente usuario:'),
    //     h('p', { class: { data: true } }, 'Usuario: ' + user.usuario),
    //     h('p', { class: { data: true } }, 'Nombre: ' + user.nombre),
    //     h('p', { class: { data: true } }, 'Apellidos: ' + user.apelli1),
    //     h('p', { class: { text: true } }, '¿Está seguro de que desea eliminar de forma permanente este usuario?')
    //   ]), 'Warning', {
    //     title: 'Confirmar eliminación permanente',
    //     confirmButtonText: 'Eliminar',
    //     cancelButtonText: 'Cancelar',
    //     type: 'warning'
    //   }).then(() => {
    //     this.$store.dispatch('deleteUserQr', user.identcli)
    //       .then((res) => {
    //         if (res.warning === true) {
    //           this.$confirm(h('div', { class: { deletemessage: true } }, [
    //             h('p', { class: { text: true } }, 'Operación no disponible para el perfil del usuario')
    //           ]), 'Warning', {
    //             title: 'Tecnichal problems detected',
    //             cancelButtonText: 'Cancelar',
    //             type: 'warning'
    //           })
    //         } else {
    //           this.showDetailPage = false
    //           this.dialogMessage = 'Usuario eliminado con éxito'
    //           this.message = true
    //           this.resetQRTable()
    //         }
    //       })
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: 'eliminación de usuario cancelada'
    //     })
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .ods-module__body {
  padding: 0;
}

.commerce-info {
  padding: rem(24);
  margin: 0 auto;

  &__title {
    margin-bottom: rem(24);
  }

  &__module {
    border-radius: 0;
    padding: rem(24);

    &--left-tabs {
      border-radius: 0;
      padding: 0;
      border: 1px solid #D5DCE0;

      /deep/ .ods-tabs--left, .ods-tabs--right {
        background: #f9f9fb;
      }

      /deep/ .ods-tabs--left .ods-tabs__header.is-left {
        float: left;
        margin-bottom: 0;
        margin-right: 0;
      }

      /deep/ .ods-tabs--left .ods-tabs__item.is-left {
        text-align: left;
        color: #6E767D;
        padding: 12px;
        border-bottom: 1px solid #D5DCE0;
        border-right: 1px solid #D5DCE0;
        background: #F9F9FB;

        &:last-child {
          border-bottom: 0;
        }

        &.is-active {
          background: #ffffff;
          border-right: 1px solid #ffffff;
          border-bottom: 1px solid #D5DCE0;
        }
      }

      /deep/ .ods-tabs__active-bar {
        display: none;
      }

      /deep/ .ods-tabs__content {
        padding: rem(24);
        border-left: 1px solid #D5DCE0;
        background: #fff;
      }
    }
  }

  // .show /deep/ .ods-input.is-disabled .ods-input__inner {
  //   background-color: transparent;
  //   border-color: transparent;
  //   color: black;
  //   cursor: not-allowed;
  //   margin-left: 0;
  //   padding-left: 0;
  // }

  &__grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    column-gap: rem(48);
  }
}

.info-box {
  margin: 0 0 rem(24) 0;

  &__title{
    margin: rem(24) 0;

    &::after {
      content: '';
      height: 2px;
      width: 100%;
      display: block;
      border-radius: 2px;
      margin-top: rem(12);
      background: #D5DCE0;
    }
  }

  .info-icon {
    float: left;
    height: rem(50);
    margin-right: rem(8);
    margin-top: rem(4);
  }
}

// .vendors-subheader {
//   display: flex;
//   justify-content: space-between;
//   // align-items: baseline;
// }

/deep/ .view-class {
  height: 80vh;
}

/deep/ header#el-drawer__title {
  margin: rem(48) rem(48) rem(24) rem(48);
  padding: 0;
  font-weight: 500;
  font-size: rem(16);
  line-height: rem(24);
  color: #060E14;
}

/deep/ .el-drawer__body {
  padding: 0 rem(48);
}

// .form-grid {
//   margin-top: rem(24);
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   grid-template-rows: auto;
//   column-gap: 48px;
// }

// .form-section:after {
//   content: '';
//   height: 1px;
//   width: 100%;
//   background: #A2ACB3;
//   display: block;
//   margin-top: rem(8);
// }

/deep/ .ods-tabs__nav{
  .ods-badge {
    top: -7px;
    float: right;
  }
}

.dialog {
  &__img {
    width: rem(100);
    margin-bottom: rem(24);
  }

  &__msg {
    color: #6E767D;
    font-size: rem(16);
    line-height: rem(24);
  }
}

.ods-divider {
  &--vertical {
    height: rem(32);
    margin-left: rem(16);
  }
}

// .advanced-search {
//   /deep/ .ods-actions-menu__button {
//     &--text {
//       color: $--color-primary;
//       font-size: 10px;
//       font-weight: 500;
//       &.ods-actions-menu__button--active {
//         background: unset;
//       }
//       &:hover {
//         background: unset;
//       }
//     }
//   }
// }
</style>
